import { Component, Vue } from 'vue-property-decorator';
import shoppingCart, { ShoppingCart } from '@/model/shopping-cart';
import checkout, { Checkout } from '@/model/checkout';

@Component
export default class ProjectMixin extends Vue {
  public shoppingCart: ShoppingCart = shoppingCart;
  public checkout: Checkout = checkout;
}
